<template>
  <generic-modal :title="$t('permissions')" ref="generic_modal" :is_wide="true">
    <div class="columns mb-0" v-for="(endpoint, idx) in endpoints" :key="idx">
      <div class="column is-two-fifths">
        <!-- <label class="label" v-if="idx == 0">{{ $t("resource") }}</label> -->
        <div class="field">
          <div class="control">
            <div class="title is-6">{{ endpoint.method.toUpperCase() }}</div>
            <div class="subtitle is-6">{{ endpoint.route }}</div>
          </div>
        </div>
      </div>
      <div class="column" v-for="(sg, sidx) in security_groups" :key="sidx">
        <div class="field">
          <input
            class="is-checkradio"
            :id="'exampleCheckbox' + sidx + '-' + idx"
            type="checkbox"
            @change="update_permissions($event, endpoint, sg)"
            :checked="
              endpoint.api_endpoint_securities.find((s) => {
                return s.security_group_id == sg.security_group_id;
              })
                ? 'checked'
                : false
            "
          />
          <label :for="'exampleCheckbox' + sidx + '-' + idx">{{
            sg.name
          }}</label>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-bind:class="{ 'is-loading': loading }"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  del,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
// import CustomerInfo from "./Customer.vue";
// import ItemsInfo from "./Items.vue";

export default {
  name: "PermissionsModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
      loading: false,
      endpoints: [],
      security_groups: [],
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.certifier || !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(api_uuid) {
      let v = this;
      v.set_initial_state();
      if (api_uuid) {
        get("/api/endpoints", { uuid: api_uuid })
          .then((response) => {
            v.endpoints = response;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.loading = true;
      v.$root.loader(true);
      put("/fel/bill", config)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.loading = false;
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      v.endpoints = [];
    },
    update_permissions(event, endpoint, sg) {
      // console.log(event, endpoint, sg);
      // console.log(
      //   event.target.checked,
      //   endpoint.endpoint_id,
      //   sg.security_group_id
      // );
      if (event.target.checked) {
        post("/api/security/permissions", {
          endpoint_id: endpoint.endpoint_id,
          security_group_id: sg.security_group_id,
        })
          .then((/* response */) => {
            // console.log("permission setted");
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      } else {
        del("/api/security/permissions", {
          endpoint_id: endpoint.endpoint_id,
          security_group_id: sg.security_group_id,
        })
          .then((/* response */) => {
            // console.log("permission removed");
          })
          .catch((error) => {
            this.error = generate_error_message_text(error);
          });
      }
    },
  },
  created() {
    let v = this;
    get("/api/security/groups")
      .then((response) => {
        v.security_groups = response;
      })
      .catch((error) => {
        v.error = generate_error_message_text(error);
      });
  },
  watch: {},
};
</script>
<style></style>
